import { render, staticRenderFns } from "./MortgageApplicationChoiceItem.vue?vue&type=template&id=1a4f0854&scoped=true&"
import script from "./MortgageApplicationChoiceItem.vue?vue&type=script&lang=js&"
export * from "./MortgageApplicationChoiceItem.vue?vue&type=script&lang=js&"
import style0 from "./MortgageApplicationChoiceItem.vue?vue&type=style&index=0&id=1a4f0854&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4f0854",
  null
  
)

export default component.exports